import { SignOutModel } from "client/Api/Authentication/authentication";
import { delay, isNotNil } from "client/Misc/utils";
import { navigateTo } from "client_legacy/ndaw/navigator";
import { shutdownIntercom } from "../Intercom/intercomWidget";

export async function init(model: SignOutModel): Promise<void> {
	const { redirectUrl, intercomAppId } = model;

	if (isNotNil(intercomAppId)) {
		await Promise.race([
			shutdownIntercom(intercomAppId),
			delay(SHUTDOWN_TIMEOUT_IN_MS)
		]);
	}

	navigateTo(redirectUrl);
}

const SHUTDOWN_TIMEOUT_IN_MS = 3_000;
